import {AuthConfig} from 'angular-oauth2-oidc';
import {environment} from '../../../environments/environment';

export const oidcConfig: AuthConfig = {
  clientId: 'green-x-hub-energy-frontend',
  issuer: environment.AUTH.OIDC_ISSUER,
  redirectUri: window.location.origin + window.location.pathname,
  requireHttps: environment.AUTH.REQUIRE_HTTPS,
  responseType: 'code',
  scope: 'openid profile email',
  showDebugInformation: true,
  silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
  silentRefreshShowIFrame: false,
};
